import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,          
  query,
  where,
  updateDoc,
  deleteDoc,
  doc
} from "firebase/firestore";
import { db, app } from "../firebase";
import axios from "axios";
import ConfirmDeleteModal from "./dialog";
import { getAuth, deleteUser } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";


const Dashboard2 = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);
    const [editingUser, setEditingUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });



useEffect(() => {
  const fetchData = async () => {
    setLoading(true);


 try {

      const q = query(collection(db, "users"), where("active", "==", true));
      const querySnapshot = await getDocs(q);

    const fetchedData = await Promise.all(
  querySnapshot.docs.map(async (userDoc) => {
    const userData = userDoc.data();

    const userId = userData.uid;
    const userPhone = userData.phone;

    // Convert to number first, fallback to 0 if invalid, then round to 4 decimal places
    const callPrice = Number(Number(userData.totalNewCallPrice) || 0).toFixed(4);
    const messagePrice = Number(Number(userData.totalMessagePrice) || 0).toFixed(4);

    return {
      id: userId,
      callPrice: Number(callPrice),       // convert back to number
      messagePrice: Number(messagePrice), // convert back to number
      ...userData,
    };
  })
);


      setData(fetchedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }

  };

  fetchData();
}, []);


const sortedData = React.useMemo(() => {
  if (!sortConfig.key) return data;

  const sorted = [...data].sort((a, b) => {
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    // Handle string comparison
    if (typeof aValue === "string") {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;
    return 0;
  });

  return sorted;
}, [data, sortConfig]);


const handleSort = (key) => {
  let direction = "ascending";
  if (sortConfig.key === key && sortConfig.direction === "ascending") {
    direction = "descending";
  }
  setSortConfig({ key, direction });
};


  // Calculate which users to display based on current page and items per page
   
  const handleEdit = (user) => {
    setEditingUser(user);
  };

  const handleDelete = (user) => {
    setUserToDelete(user);
    setIsModalOpen(true, user );
  };

  const confirmDelete = async () => {
    try {
        // Find the user document based on the `uid`
      const q = query(collection(db, "users"), where("uid", "==", userToDelete.uid));
      const querySnapshot = await getDocs(q);
      
    
      const userDoc = querySnapshot.docs[0].ref;
        const userData = querySnapshot.docs[0].data();
 
    
      // Print the document reference
      console.log("Document reference to delete:", userDoc);
      
      // Proceed with deletion
    await deleteDoc(userDoc);

    

   // await deleteUser(user);  // Delete the user from Firebase Authentication
    //   console.log("User deleted from Firebase Authentication");

      // Remove the deleted user from the local state
      setData(data.filter((user) => user.uid !== userToDelete.uid));
      
      // Close the modal
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error deleting user:", error);
      setIsModalOpen(false);  // Close modal if error occurs
    }
  };

  const cancelDelete = () => {
    setIsModalOpen(false);  // Close modal if user cancels
  };
  const handleUpdate = async (updatedUser) => {
    try {
      console.log(`Updating user with UID: ${updatedUser.uid}`);
      
      // Find the user document based on the `uid`
      const q = query(collection(db, "users"), where("uid", "==", updatedUser.uid));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        // Assuming `uid` is unique and there's only one document
        const userDoc = querySnapshot.docs[0].ref;
        const userData = querySnapshot.docs[0].data();
  
        // Print the user's current name to verify
        console.log(`Current name for UID ${updatedUser.uid}: ${userData.name}`);
  
       // Uncomment these lines to update the name and local state
        await updateDoc(userDoc, { name: updatedUser.name });
        setData(data.map((user) => 
          user.uid === updatedUser.uid ? { ...user, name: updatedUser.name } : user
        ));
        setEditingUser(null);
      } else {
        console.error("User not found.");
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };
    console.log("data");
  console.log(data);
  return (
    <div>
      <h1>User Dashboard</h1>
      {loading ? (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <div>
        
          <table>
            <thead>
  <tr>
    <th onClick={() => handleSort("name")}>Name</th>
    <th onClick={() => handleSort("email")}>Email</th>
    <th onClick={() => handleSort("phone")}>Phone</th>
    <th onClick={() => handleSort("callPrice")}>Total Call Price</th>
    <th onClick={() => handleSort("messagePrice")}>Total Message Price</th>
    <th onClick={() => handleSort("active")}>Active</th>
    <th onClick={() => handleSort("battery_level")}>Battery Level</th>
    <th>Actions</th>
  </tr>
</thead>
            <tbody>
  {sortedData.map((user) => (
    <tr key={user.id}>
      <td>{user.name}</td>
      <td>{user.email}</td>
      <td>{user.phone}</td>
      <td>${user.callPrice}</td>
      <td>${user.messagePrice}</td>
      <td>{user.active ? "Yes" : "No"}</td>
      <td>{user.battery_level}</td>
      <td>
        <button onClick={() => handleEdit(user)}>Edit</button>
        <button onClick={() => handleDelete(user)}>Delete</button>
      </td>
    </tr>
  ))}
</tbody>
          </table>

          {/* Edit User Overlay */}
          {editingUser && (
            <div className="overlay">
              <div className="overlay-content">
                <h2>Edit User</h2>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleUpdate(editingUser);
                  }}
                >
                  <input
                    type="text"
                    value={editingUser.name}
                    onChange={(e) => setEditingUser({ ...editingUser, name: e.target.value })}
                    placeholder="Name"
                  />
                  <input
                    type="email"
                    value={editingUser.email}
                    onChange={(e) => setEditingUser({ ...editingUser, email: e.target.value })}
                    placeholder="Email"
                  />
                  <input
                    type="text"
                    value={editingUser.phone}
                    onChange={(e) => setEditingUser({ ...editingUser, phone: e.target.value })}
                    placeholder="Phone"
                  />
                  {/* Additional fields can be added here */}
                  <button type="submit">Save</button>
                  <button type="button" onClick={() => setEditingUser(null)}>
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
           {/* Confirm Delete Modal */}
           <ConfirmDeleteModal 
  isOpen={isModalOpen} 
  onCancel={cancelDelete} 
  onConfirm={confirmDelete} 
  UserToDelete={userToDelete} 
  
/>
        </div>
      )}
    </div>
  );
};

export default Dashboard2;
